/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Seo_Endpoint_A_FailoverInputs */

const en_seo_endpoint_a_failover = /** @type {(inputs: Seo_Endpoint_A_FailoverInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`AnyAPI asks the next of its ${i?.count} sources in the same request, cheapest first, so one source going down does not fail your call.`)
};

const zh_hans1_seo_endpoint_a_failover = /** @type {(inputs: Seo_Endpoint_A_FailoverInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`AnyAPI 会在同一个请求中依次尝试它的 ${i?.count} 个数据源，从最便宜的开始，所以一个数据源宕机不会让你的调用失败。`)
};

const pt_br2_seo_endpoint_a_failover = /** @type {(inputs: Seo_Endpoint_A_FailoverInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`A AnyAPI consulta a próxima das suas ${i?.count} fontes na mesma requisição, começando pela mais barata, então a queda de uma fonte não derruba sua chamada.`)
};

const es_seo_endpoint_a_failover = /** @type {(inputs: Seo_Endpoint_A_FailoverInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`AnyAPI consulta la siguiente de sus ${i?.count} fuentes en la misma solicitud, empezando por la más barata, así que la caída de una fuente no hace fallar tu llamada.`)
};

const fr_seo_endpoint_a_failover = /** @type {(inputs: Seo_Endpoint_A_FailoverInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`AnyAPI interroge la suivante de ses ${i?.count} sources dans la même requête, la moins chère d’abord, donc la panne d’une source ne fait pas échouer votre appel.`)
};

const de_seo_endpoint_a_failover = /** @type {(inputs: Seo_Endpoint_A_FailoverInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`AnyAPI fragt in derselben Anfrage die nächste seiner ${i?.count} Quellen, die günstigste zuerst, sodass der Ausfall einer Quelle deinen Aufruf nicht scheitern lässt.`)
};

const ru_seo_endpoint_a_failover = /** @type {(inputs: Seo_Endpoint_A_FailoverInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`AnyAPI в том же запросе обращается к следующему из источников (их ${i?.count}), начиная с самого дешёвого, поэтому отказ одного источника не ломает ваш вызов.`)
};

const it_seo_endpoint_a_failover = /** @type {(inputs: Seo_Endpoint_A_FailoverInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`AnyAPI interroga la successiva delle sue ${i?.count} fonti nella stessa richiesta, partendo dalla più economica, quindi una fonte che cade non fa fallire la tua chiamata.`)
};

/**
* | output |
* | --- |
* | "AnyAPI asks the next of its {count} sources in the same request, cheapest first, so one source going down does not fail your call." |
*
* @param {Seo_Endpoint_A_FailoverInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const seo_endpoint_a_failover = /** @type {((inputs: Seo_Endpoint_A_FailoverInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seo_Endpoint_A_FailoverInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_seo_endpoint_a_failover(inputs)
	if (locale === "pt-BR") return pt_br2_seo_endpoint_a_failover(inputs)
	if (locale === "es") return es_seo_endpoint_a_failover(inputs)
	if (locale === "fr") return fr_seo_endpoint_a_failover(inputs)
	if (locale === "de") return de_seo_endpoint_a_failover(inputs)
	if (locale === "ru") return ru_seo_endpoint_a_failover(inputs)
	if (locale === "it") return it_seo_endpoint_a_failover(inputs)
	return en_seo_endpoint_a_failover(inputs)
});